(() => {
  function initializeReturns(scope = document) {
    const form = scope.querySelector('#ReturnsForm');
    if (!form || form.dataset.returnsReady || !form.querySelector('[data-returns-fields]')) return;
    form.dataset.returnsReady = 'true';
    const fields = form.querySelector('[data-returns-fields]');
    const review = form.querySelector('[data-returns-review]');
    const summary = form.querySelector('[data-returns-summary]');
    const confirmation = form.querySelector('[data-returns-confirm]');
    const checkbox = form.querySelector('#ReturnsConfirm');
    const reviewButton = form.querySelector('[data-returns-review-button]');
    const submit = form.querySelector('[data-returns-submit]');
    const type = form.querySelector('#ReturnsType');
    let reviewed = false;

    function updateSubmitLabel() {
      submit.textContent = type.value === 'Withdrawal from an online purchase' || type.value === 'Cancellation before delivery'
        ? 'Confirm withdrawal' : 'Confirm and send request';
    }
    function edit() {
      reviewed = false;
      fields.hidden = false;
      review.hidden = true;
      confirmation.hidden = true;
      checkbox.checked = false;
      checkbox.required = false;
      reviewButton.hidden = false;
    }
    function showReview() {
      fields.querySelectorAll('input[type="text"][required], textarea[required]').forEach((field) => {
        field.value = field.value.trim();
      });
      if (!form.reportValidity()) return;
      summary.replaceChildren();
      fields.querySelectorAll('[data-summary-label]').forEach((field) => {
        if (!field.value.trim()) return;
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = field.dataset.summaryLabel;
        description.textContent = field.tagName === 'SELECT' ? field.selectedOptions[0].textContent : field.value;
        summary.append(term, description);
      });
      fields.hidden = true;
      review.hidden = false;
      confirmation.hidden = false;
      checkbox.required = true;
      reviewButton.hidden = true;
      reviewed = true;
      updateSubmitLabel();
      review.querySelector('[data-returns-review-heading]').focus();
    }
    reviewButton.addEventListener('click', showReview);
    form.querySelector('[data-returns-edit]').addEventListener('click', () => {
      edit();
      fields.querySelector('input').focus();
    });
    type.addEventListener('change', updateSubmitLabel);
    form.addEventListener('submit', (event) => {
      if (!reviewed) {
        event.preventDefault();
        showReview();
      }
    });
    edit();
    updateSubmitLabel();
  }
  initializeReturns();
  document.addEventListener('shopify:section:load', (event) => initializeReturns(event.target));
})();
